export function exhibition() {
  const $exhibitionStand = $('.exhibition-stand');
  if(!$exhibitionStand || $exhibitionStand.length === 0) return;

  const $standPoll = $('.exhibition-stand-container-poll');
  const $standMaterial = $('.exhibition-stand-container-material');
  const $standPollHover = $('.exhibition-stand-path-hover-poll');
  const $standMaterialHover = $('.exhibition-stand-path-hover-material');

  $standPoll.on('mouseenter', function () {
    $standPollHover.addClass('active');
  });

  $standPoll.on('mouseleave', function () {
    $standPollHover.removeClass('active');
  });

  $standMaterial.on('mouseenter', function () {
    $standMaterialHover.addClass('active');
  });

  $standMaterial.on('mouseleave', function () {
    $standMaterialHover.removeClass('active');
  });
}
